import { CustomerInfo } from '@/domain/CustomerInfo'
import { UserInfo } from '@/domain/UserInfo'
import { Invoice, InvoiceDetail } from '@/domain/Invoice'
import FileData from '@/domain/FileData'
import DateUtils from '@/utils/DateUtils'

/**
 * 請求
 */
export class TotalInvoice {
    /** 合計請求番号 */
    totalInvoiceNo = ""
    /** 合計請求日 YYYY-MM-DD */
    totalInvoiceOn = ""
    /** 合算開始日 YYYY-MM-DD */
    startOn = ""
    /** 合算終了日 YYYY-MM-DD */
    endOn = ""
    /** 作成者 */
    authorUser = new UserInfo()
    /** 承認者 */
    authorizerUser = new UserInfo()
    /** 顧客情報 */
    customerInfo = new CustomerInfo()
    /** 小計 */
    amount = 0
    /** 消費税 */
    tax = 0
    /** 手数料 */
    fee = 0
    /** 備考 */
    note = ""
    /** メール送信日時 */
    mailSendAt: string | null = null
    /** 印刷日時 */
    printAt: string | null = null
    /** 角印の押印 0:なし 1:あり */
    imprint = true
    /** 請求日印刷有無 0:なし 1:あり */
    printInvoiceOn = true

    /* 合算請求対象 */
    invoices: Invoice[] = []

    /* 合算請求対象明細 */
    details: InvoiceDetail[] = []

    /** 合算請求書 */
    totalInvoiceFile: FileData = new FileData()

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<TotalInvoice>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new TotalInvoice(JSON.parse(JSON.stringify(this)));
    }

    /**
     * 明細を集計する
     */
    sum() {
        if (this.invoices.length === 0) {
            this.amount = 0
            this.tax = 0
            this.fee = 0
        }
        this.amount = this.invoices
            .map(x => x.sumInfo.amount)
            .reduce((p, x) => p + x, 0)
        this.tax = this.invoices
            .map(x => x.sumInfo.tax)
            .reduce((p, x) => p + x, 0)
        this.fee = this.invoices
            .map(x => x.sumInfo.fee)
            .reduce((p, x) => p + x, 0)
    }

    /**
     * メール送信済みか？
     */
    get isMailSended() {
        return !(this.mailSendAt === null || this.mailSendAt === "")
    }

    /**
     * 印刷済みか？
     */
    get isPrinted() {
        return !(this.printAt === null || this.printAt === "")
    }

    /**
     * ロック状態(編集不可)か？
     */
    get isLocked() {
        return false
    }

    /**
     * 小計（カンマ区切り）
     */
    get amountText() {
        return isNaN(this.amount) ? "-" : this.amount.toLocaleString()
    }

    /**
     * 消費税（カンマ区切り）
     */
    get taxText() {
        return isNaN(this.tax) ? "-" : this.tax.toLocaleString()
    }

    /**
     * 合計金額
     */
    get totalAmount() {
        return this.amount + this.tax
    }

    /**
     * 合計金額（カンマ区切り）
     */
    get totalAmountText() {
        return isNaN(this.totalAmount) ? "-" : this.totalAmount.toLocaleString()
    }

    /**
     * フィルターキーワードの取得
     */
    get filterKeyword() {
        const dateUtils = DateUtils.instance
        return `${dateUtils.toJapanFormat(this.totalInvoiceOn)} ${this.totalInvoiceNo} ${this.customerInfo.customerName}`
    }
}
